export default __webpack_public_path__ + "2a6684d5d4eab0a0aee1eed152f3c57a.jpg";